import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { AppTelemetryService, TelemetryAttributes } from './app-telemetry.service';

@Injectable({ providedIn: 'root' })
export class FrontendRouteObservabilityService {
  constructor(
    router: Router,
    appTelemetry: AppTelemetryService,
  ) {
    router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const routeInfo = resolveRouteInfo(router.routerState.snapshot.root);
        appTelemetry.trackView(routeInfo.routeTemplate, {
          ...routeInfo.attributes,
          url: event.urlAfterRedirects,
        });
      });
  }
}

interface RouteInfo {
  routeTemplate: string;
  attributes: TelemetryAttributes;
}

function resolveRouteInfo(root: ActivatedRouteSnapshot): RouteInfo {
  const paths: string[] = [];
  const attributes: TelemetryAttributes = {};
  let current: ActivatedRouteSnapshot | null = root;

  while (current) {
    const routePath = current.routeConfig?.path;
    if (routePath && routePath !== '**') {
      paths.push(routePath);
    }

    for (const [key, value] of Object.entries(current.params)) {
      attributes[toTelemetryAttributeName(key)] = value;
    }

    current = current.firstChild;
  }

  return {
    routeTemplate: paths.length > 0 ? `/${paths.join('/')}` : '/',
    attributes,
  };
}

function toTelemetryAttributeName(paramName: string): string {
  return paramName.replace(/-([a-z])/g, (_, letter: string) => letter.toUpperCase());
}
